var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3517.325,
    height: 1990.594,
    viewBox: "0 0 3517.325 1990.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.069,
    y1: 8.116,
    x2: -0.069,
    y2: 8.116,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eae6cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#727271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#313030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#313030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "#313030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#727271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.8,
    cy: 0.733,
    r: 8.484,
    gradientTransform: "translate(-3.185 13.178) scale(0.075 0.152)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0d0ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3f3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M3379.752-384.626h-7.573a96.384,96.384,0,0,0,52.88-86.04V-2229.794a96.408,96.408,0,0,0-96.4-96.4H667.565a96.409,96.409,0,0,0-96.4,96.4V-470.665h0a96.38,96.38,0,0,0,52.876,86.04h-7.569a100.439,100.439,0,0,1-49.079-86.266V-2229.554a100.526,100.526,0,0,1,100.4-100.413H3328.432a100.526,100.526,0,0,1,100.4,100.413V-470.892a100.457,100.457,0,0,1-49.08,86.266"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.198,
    y1: 1.198,
    x2: -0.198,
    y2: 1.198,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#46474b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#46474b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#5c5d61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#5c5d61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#46474b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#46474b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46474b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "M3758.657-384.626H241.333v-54.053H3758.657Z",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "M1773.089-400.959h428.665a37.727,37.727,0,0,0,37.72-37.72H1735.382a37.715,37.715,0,0,0,37.707,37.72Z",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "M3494.991-339.693q-10.68-.26-21.733-.307c-1.587-.013-3.173-.013-4.786-.013H531.512c-1.6,0-3.189,0-4.779.013-7.363.027-14.62.133-21.733.307-166.077-4.04-263.667-44.933-263.667-44.933H3758.658s-97.586,40.893-263.666,44.933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.069,
    y1: 8.56,
    x2: -0.069,
    y2: 8.56,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#343539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path130",
    d: "M3413.592-490.439H2014.408l16.827-58.893h1332.09V-2218.661H2508.18l27.453-96.067h798.385a79.678,79.678,0,0,1,79.573,79.213V-490.439"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -1.44,
    y1: 1.269,
    x2: -1.44,
    y2: 1.269,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path146",
    d: "M3363.325-549.332H2031.235L2508.18-2218.661h855.145V-549.332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1.525,
    y1: 1.329,
    x2: -1.525,
    y2: 1.329,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path174",
    d: "M3473.258-340H526.733c1.589-.013,3.177-.013,4.779-.013h2936.96c1.613,0,3.2,0,4.786.013"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 4606 3"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4606,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAEf4AAAADCAYAAADc4qmdAAAABHNCSVQICAgIfAhkiAAAAFtJREFUeJzt3EENACAMBDBIsLHMv8rDxb1aIb27kwMAAAAAAAAAAAAAAAAAAAAAAFS8xPsDAAAAAAAAAAAAAAAAAAAAAAAt4h8AAAAAAAAAAAAAAAAAAAAAACj6Qu0HXoi0tz8AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path198",
    d: "M3468.472-339.372H531.512q-13.524,0-26.512-.32c7.113-.173,14.371-.28,21.733-.307H3473.258q11.04.04,21.733.307-12.98.32-26.52.32"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-2",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 4674 4"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4674,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAEkIAAAAECAYAAADMz5STAAAABHNCSVQICAgIfAhkiAAAAHVJREFUeJzt3EERACAMBDGOwQVT/zJBRh9NFKyCTdV9CwAAAAAAAAAAAAAAAAAAAAAAoMHuDgAAAAAAAAAAAAAAAAAAAAAAAOYyQgIAAAAAAAAAAAAAAAAAAAAAANqcJN0NAAAAAAAAAAAAAAAAAAAAAADAUB80LAFh3sHH5gAAAABJRU5ErkJggg=="
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_875",
    "data-name": "Group 875",
    transform: "translate(-13248.837 -22526.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "translate(13007.504 24856.709)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g16",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M3379.752-384.626h-7.573a96.384,96.384,0,0,0,52.88-86.04V-2229.794a96.408,96.408,0,0,0-96.4-96.4H667.565a96.409,96.409,0,0,0-96.4,96.4V-470.665h0a96.38,96.38,0,0,0,52.876,86.04h-7.569a100.439,100.439,0,0,1-49.079-86.266V-2229.554a100.526,100.526,0,0,1,100.4-100.413H3328.432a100.526,100.526,0,0,1,100.4,100.413V-470.892a100.457,100.457,0,0,1-49.08,86.266",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M573.832-470.665H576.5V-2229.794a90.753,90.753,0,0,1,26.672-64.386,90.787,90.787,0,0,1,64.395-26.68H3328.658a90.77,90.77,0,0,1,64.386,26.68,90.716,90.716,0,0,1,26.68,64.386V-470.665a90.748,90.748,0,0,1-26.68,64.4,90.759,90.759,0,0,1-64.386,26.667H667.565a90.776,90.776,0,0,1-64.395-26.667,90.785,90.785,0,0,1-26.672-64.4h-5.333a96.392,96.392,0,0,0,96.4,96.4H3328.658a96.392,96.392,0,0,0,96.4-96.4V-2229.794a96.409,96.409,0,0,0-96.4-96.4H667.565a96.409,96.409,0,0,0-96.4,96.4V-470.665h2.667"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M576.347-470.506V-2229.941a91.067,91.067,0,0,1,91.065-91.066H3328.805a91.068,91.068,0,0,1,91.066,91.066V-470.506a91.068,91.068,0,0,1-91.066,91.066H667.412a91.067,91.067,0,0,1-91.065-91.066",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M576.347-470.506h2.667V-2229.941a88.079,88.079,0,0,1,25.891-62.507,88.111,88.111,0,0,1,62.508-25.893H3328.805a88.086,88.086,0,0,1,62.506,25.893,88.086,88.086,0,0,1,25.893,62.507V-470.506A88.11,88.11,0,0,1,3391.312-408a88.086,88.086,0,0,1-62.506,25.893H667.412A88.111,88.111,0,0,1,604.9-408a88.1,88.1,0,0,1-25.891-62.507H573.68a93.728,93.728,0,0,0,93.732,93.733H3328.805a93.725,93.725,0,0,0,93.733-93.733V-2229.941a93.725,93.725,0,0,0-93.733-93.733H667.412a93.728,93.728,0,0,0-93.732,93.733V-470.506h2.667",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M582.631-470.119h1.333V-2230.328a82.82,82.82,0,0,1,24.329-58.733,82.781,82.781,0,0,1,58.737-24.333H3329.192a82.79,82.79,0,0,1,58.733,24.333,82.788,82.788,0,0,1,24.333,58.733V-470.119a82.788,82.788,0,0,1-24.333,58.733,82.9,82.9,0,0,1-58.733,24.333H667.03a82.892,82.892,0,0,1-58.737-24.333,82.821,82.821,0,0,1-24.329-58.733H581.3A85.724,85.724,0,0,0,667.03-384.4H3329.192a85.725,85.725,0,0,0,85.733-85.72V-2230.328a85.737,85.737,0,0,0-85.733-85.733H667.03a85.736,85.736,0,0,0-85.733,85.733V-470.119h1.333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "M582.631-490.439V-2235.155a79.671,79.671,0,0,1,79.574-79.573H3334.019a79.676,79.676,0,0,1,79.573,79.573V-490.439H582.631",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g52",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "M3758.657-384.626H241.333v-54.053H3758.657v54.053",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g84",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "M1773.089-400.959h428.665a37.727,37.727,0,0,0,37.72-37.72H1735.382a37.715,37.715,0,0,0,37.707,37.72",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "M241.333-438.506H3758.657v-.333H241.333Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g106",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "M3494.991-339.693q-10.68-.26-21.733-.307c-1.587-.013-3.173-.013-4.786-.013H531.512c-1.6,0-3.189,0-4.779.013-7.363.027-14.62.133-21.733.307-166.077-4.04-263.667-44.933-263.667-44.933H3758.658s-97.586,40.893-263.666,44.933",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "M636.665-549.332h2726.66V-2218.661H636.665Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "M3413.592-490.439h0v0",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g128",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "M3413.592-490.439H2014.408l16.827-58.893h1332.09V-2218.661H2508.18l27.453-96.067h798.385a79.678,79.678,0,0,1,79.573,79.213V-490.439",
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g144",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "M3363.325-549.332H2031.235L2508.18-2218.661h855.145V-549.332",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    d: "M1944-485.025h3.413v23.587h11.307v2.867H1944v-26.453",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "M1972.422-468.266c-3.773-.08-8.04.6-8.04,4.28a3.056,3.056,0,0,0,3.253,3.307,4.723,4.723,0,0,0,4.587-3.187,3.514,3.514,0,0,0,.2-1.093Zm.507,9.693-.267-2.387h-.12a7.093,7.093,0,0,1-5.813,2.827,5.407,5.407,0,0,1-5.8-5.453c0-4.6,4.08-7.107,11.413-7.067v-.4c0-1.573-.427-4.387-4.32-4.387a9.606,9.606,0,0,0-4.947,1.4l-.787-2.267a11.775,11.775,0,0,1,6.253-1.693c5.8,0,7.213,3.96,7.213,7.773v7.107a26.119,26.119,0,0,0,.32,4.547h-3.146",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    d: "M1984.755-466.292a7.472,7.472,0,0,0,.16,1.4,5.332,5.332,0,0,0,5.187,4.053c3.64,0,5.76-2.987,5.76-7.347,0-3.8-2-7.067-5.64-7.067a5.52,5.52,0,0,0-5.227,4.28,5.5,5.5,0,0,0-.24,1.413Zm-3.413-5.067c0-2.44-.08-4.4-.16-6.2h3.107l.16,3.253h.08a7.45,7.45,0,0,1,6.747-3.693c4.587,0,8.053,3.893,8.053,9.653,0,6.84-4.173,10.213-8.64,10.213a6.667,6.667,0,0,1-5.853-2.987h-.08v10.32h-3.413v-20.56",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    d: "M2007.848-483.025v5.467h4.947v2.627h-4.947v10.24c0,2.36.667,3.693,2.587,3.693a7.673,7.673,0,0,0,2.013-.24l.147,2.587a8.264,8.264,0,0,1-3.053.48,4.779,4.779,0,0,1-3.733-1.453c-.987-1.027-1.333-2.707-1.333-4.947v-10.36h-2.947v-2.627h2.947v-4.56l3.373-.907",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    d: "M2018.568-468.025c0,4.16,2.4,7.307,5.773,7.307,3.307,0,5.773-3.107,5.773-7.387,0-3.213-1.613-7.307-5.693-7.307s-5.853,3.773-5.853,7.387Zm15.08-.2c0,7.027-4.867,10.093-9.467,10.093-5.133,0-9.107-3.773-9.107-9.773,0-6.36,4.173-10.093,9.427-10.093,5.453,0,9.147,3.96,9.147,9.773",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "M2041.435-466.292a7.472,7.472,0,0,0,.16,1.4,5.328,5.328,0,0,0,5.173,4.053c3.653,0,5.774-2.987,5.774-7.347,0-3.8-2-7.067-5.654-7.067a5.52,5.52,0,0,0-5.227,4.28,6.136,6.136,0,0,0-.227,1.413Zm-3.413-5.067c0-2.44-.08-4.4-.16-6.2h3.093l.16,3.253h.08a7.465,7.465,0,0,1,6.747-3.693c4.6,0,8.053,3.893,8.053,9.653,0,6.84-4.16,10.213-8.64,10.213a6.66,6.66,0,0,1-5.84-2.987h-.08v10.32h-3.413v-20.56",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g172",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g178",
    transform: "translate(525.985 -338.919)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "image180",
    width: 2948.019,
    height: 2.027,
    transform: "translate(0 -2.027)",
    fill: "url(#pattern)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g196",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g202",
    transform: "translate(504.252 -338.252)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "image204",
    width: 2991.486,
    height: 2.693,
    transform: "translate(0 -2.693)",
    fill: "url(#pattern-2)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749",
    transform: "translate(-1795.001 12936.039)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CollegeSharing",
    transform: "translate(15787 9842)",
    fill: "#0e7f8a",
    fontSize: 80,
    fontFamily: "Righteous-Regular, Righteous"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -277.09,
    y: 0
  }, "CollegeSharing")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 2727,
    height: 5,
    transform: "translate(15439 9925)",
    fill: "#0e7f8a",
    opacity: 0.243
  }), /*#__PURE__*/React.createElement("g", {
    id: "search-engine",
    transform: "translate(16149.756 9558.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M467.307,321.2H33.069A25.051,25.051,0,0,1,8.017,296.151V212.644a25.051,25.051,0,0,1,25.052-25.052H467.307a25.051,25.051,0,0,1,25.052,25.052v83.507A25.052,25.052,0,0,1,467.307,321.2Z",
    transform: "translate(-0.188 -0.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M475.725,321.2H367.165V187.591h108.56a25.051,25.051,0,0,1,25.052,25.052V296.15A25.052,25.052,0,0,1,475.725,321.2Z",
    transform: "translate(-8.605 -0.188)",
    fill: "#c4e6eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M467.119,179.574H32.881A32.918,32.918,0,0,0,0,212.455v83.507a32.918,32.918,0,0,0,32.881,32.881H467.119A32.918,32.918,0,0,0,500,295.962V212.455A32.919,32.919,0,0,0,467.119,179.574Zm17.224,116.389a17.243,17.243,0,0,1-17.224,17.224H32.881a17.243,17.243,0,0,1-17.224-17.224V212.456a17.243,17.243,0,0,1,17.224-17.224H467.119a17.243,17.243,0,0,1,17.224,17.224Z",
    fill: "#474d54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M454.345,263.7a32.9,32.9,0,1,0-11.07,11.07l19.178,19.178a7.828,7.828,0,0,0,11.07-11.071ZM409.01,246.66a17.224,17.224,0,1,1,17.224,17.224A17.243,17.243,0,0,1,409.01,246.66Z",
    transform: "translate(-9.219 -0.802)",
    fill: "#0e7f8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M42.033,213.779a7.829,7.829,0,0,0-7.829,7.829v66.806a7.829,7.829,0,1,0,15.658,0V221.608A7.829,7.829,0,0,0,42.033,213.779Z",
    transform: "translate(-0.802 -0.802)",
    fill: "#0e7f8a",
    opacity: 0.725
  })), /*#__PURE__*/React.createElement("g", {
    id: "profile-user",
    transform: "translate(17948 9752.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M60.7,0a60.7,60.7,0,1,0,60.7,60.7A60.7,60.7,0,0,0,60.7,0Zm0,18.149A20.076,20.076,0,1,1,40.625,38.226,20.078,20.078,0,0,1,60.7,18.15Zm-.013,87.374a44.546,44.546,0,0,1-29.008-10.7,8.555,8.555,0,0,1-3-6.5A20.247,20.247,0,0,1,49.021,68.082H72.382A20.218,20.218,0,0,1,92.7,88.324a8.534,8.534,0,0,1-3,6.5A44.531,44.531,0,0,1,60.685,105.523Z",
    transform: "translate(0 0)",
    fill: "#0e7f8a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "profile-user-2",
    "data-name": "profile-user",
    transform: "translate(17948 9752.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1063-2",
    "data-name": "Path 1063",
    d: "M60.7,0a60.7,60.7,0,1,0,60.7,60.7A60.7,60.7,0,0,0,60.7,0Zm0,18.149A20.076,20.076,0,1,1,40.625,38.226,20.078,20.078,0,0,1,60.7,18.15Zm-.013,87.374a44.546,44.546,0,0,1-29.008-10.7,8.555,8.555,0,0,1-3-6.5A20.247,20.247,0,0,1,49.021,68.082H72.382A20.218,20.218,0,0,1,92.7,88.324a8.534,8.534,0,0,1-3,6.5A44.531,44.531,0,0,1,60.685,105.523Z",
    transform: "translate(0 0)",
    fill: "#0e7f8a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750",
    transform: "translate(-1798.001 12944.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checked",
    transform: "translate(15937 9992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M63.5,0A63.5,63.5,0,1,1,0,63.5,63.5,63.5,0,0,1,63.5,0Z",
    transform: "translate(0 0)",
    fill: "#78bfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M188.8,206.085l32.651,32.651a63.458,63.458,0,0,0,47.074-61.3v-1.8L242.885,152Z",
    transform: "translate(-141.526 -113.94)",
    fill: "#0e7f8a",
    opacity: 0.238
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643",
    transform: "translate(21.334 31.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M128.969,227.344a7.5,7.5,0,0,1,0,10.416l-5.809,5.809a7.5,7.5,0,0,1-10.416,0L87.3,217.929a7.5,7.5,0,0,1,0-10.416l5.809-5.809a7.5,7.5,0,0,1,10.416,0Z",
    transform: "translate(-85.2 -180.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M210.573,127.3a7.5,7.5,0,0,1,10.416,0l5.809,5.809a7.5,7.5,0,0,1,0,10.416L182.729,187.4a7.5,7.5,0,0,1-10.416,0l-5.809-5.809a7.5,7.5,0,0,1,0-10.416Z",
    transform: "translate(-144.569 -125.2)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "checked-2",
    "data-name": "checked",
    transform: "translate(16336 9992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1067-2",
    "data-name": "Path 1067",
    d: "M63.5,0A63.5,63.5,0,1,1,0,63.5,63.5,63.5,0,0,1,63.5,0Z",
    transform: "translate(0 0)",
    fill: "#78bfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064-2",
    "data-name": "Path 1064",
    d: "M188.8,206.085l32.651,32.651a63.458,63.458,0,0,0,47.074-61.3v-1.8L242.885,152Z",
    transform: "translate(-141.526 -113.94)",
    fill: "#0e7f8a",
    opacity: 0.238
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_643-2",
    "data-name": "Group 643",
    transform: "translate(21.334 31.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1065-2",
    "data-name": "Path 1065",
    d: "M128.969,227.344a7.5,7.5,0,0,1,0,10.416l-5.809,5.809a7.5,7.5,0,0,1-10.416,0L87.3,217.929a7.5,7.5,0,0,1,0-10.416l5.809-5.809a7.5,7.5,0,0,1,10.416,0Z",
    transform: "translate(-85.2 -180.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066-2",
    "data-name": "Path 1066",
    d: "M210.573,127.3a7.5,7.5,0,0,1,10.416,0l5.809,5.809a7.5,7.5,0,0,1,0,10.416L182.729,187.4a7.5,7.5,0,0,1-10.416,0l-5.809-5.809a7.5,7.5,0,0,1,0-10.416Z",
    transform: "translate(-144.569 -125.2)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 63.5,
    cy: 63.5,
    r: 63.5,
    transform: "translate(16735 9992)",
    fill: "#d7e0e2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    cx: 63.5,
    cy: 63.5,
    r: 63.5,
    transform: "translate(17134 9992)",
    fill: "#d7e0e2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_145",
    "data-name": "Ellipse 145",
    cx: 63.5,
    cy: 63.5,
    r: 63.5,
    transform: "translate(17533 9992)",
    fill: "#d7e0e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 235,
    height: 8,
    rx: 4,
    transform: "translate(16081 10052)",
    fill: "#78bfc9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 235,
    height: 8,
    rx: 4,
    transform: "translate(16480 10048)",
    fill: "#78bfc9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 235,
    height: 8,
    rx: 4,
    transform: "translate(16882 10048)",
    fill: "#d7e0e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 235,
    height: 8,
    rx: 4,
    transform: "translate(17278 10048)",
    fill: "#d7e0e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751",
    transform: "translate(-1567.001 11500.039)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 709,
    height: 779,
    transform: "translate(15355 11829)",
    fill: "#f0f7f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    transform: "translate(15848 11856)",
    fill: "#0e7f8a",
    stroke: "#fff",
    strokeWidth: 4,
    opacity: 0.787
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 73,
    rx: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 166,
    height: 69,
    rx: 13,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 189,
    height: 22,
    rx: 10,
    transform: "translate(15408 11966)",
    fill: "#737d88",
    opacity: 0.347
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 244,
    height: 42,
    rx: 10,
    transform: "translate(15408 12001)",
    fill: "#737d88",
    opacity: 0.347
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 244,
    height: 42,
    rx: 10,
    transform: "translate(15408 12183)",
    fill: "#737d88",
    opacity: 0.347
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 189,
    height: 22,
    rx: 10,
    transform: "translate(15408 12113)",
    fill: "#737d88",
    opacity: 0.347
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 189,
    height: 22,
    rx: 10,
    transform: "translate(15408 12148)",
    fill: "#737d88",
    opacity: 0.347
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 244,
    height: 231,
    rx: 10,
    transform: "translate(15408 12313)",
    fill: "#737d88",
    opacity: 0.347
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 269,
    height: 77,
    rx: 10,
    transform: "translate(15749 11966)",
    fill: "#737d88",
    opacity: 0.588
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 225,
    height: 22,
    rx: 10,
    transform: "translate(15793 12113)",
    fill: "#737d88",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 189,
    height: 22,
    rx: 10,
    transform: "translate(15829 12148)",
    fill: "#737d88",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 269,
    height: 64,
    rx: 10,
    transform: "translate(15749 12480)",
    fill: "#737d88",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 269,
    height: 148,
    rx: 10,
    transform: "translate(15749 12281)",
    fill: "#737d88",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 358,
    height: 779,
    transform: "translate(15706 11829)",
    fill: "#d6e4e6",
    opacity: 0.687
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 709,
    height: 121,
    transform: "translate(15355 11829)",
    fill: "#0e7f8a",
    opacity: 0.173
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752",
    transform: "translate(105.999 11424.039)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209-2",
    "data-name": "Rectangle 209",
    width: 709,
    height: 779,
    transform: "translate(15405 11906)",
    fill: "#f0f7f8",
    opacity: 0.614
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_212-2",
    "data-name": "Rectangle 212",
    transform: "translate(15898 11933)",
    fill: "#0e7f8a",
    stroke: "#fff",
    strokeWidth: 4,
    opacity: 0.787
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 73,
    rx: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 166,
    height: 69,
    rx: 13,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213-2",
    "data-name": "Rectangle 213",
    width: 189,
    height: 22,
    rx: 10,
    transform: "translate(15458 12043)",
    fill: "#737d88",
    opacity: 0.347
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214-2",
    "data-name": "Rectangle 214",
    width: 244,
    height: 42,
    rx: 10,
    transform: "translate(15458 12078)",
    fill: "#737d88",
    opacity: 0.347
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215-2",
    "data-name": "Rectangle 215",
    width: 244,
    height: 98,
    rx: 10,
    transform: "translate(15458 12260)",
    fill: "#737d88",
    opacity: 0.347
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216-2",
    "data-name": "Rectangle 216",
    width: 189,
    height: 22,
    rx: 10,
    transform: "translate(15458 12190)",
    fill: "#737d88",
    opacity: 0.347
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217-2",
    "data-name": "Rectangle 217",
    width: 189,
    height: 22,
    rx: 10,
    transform: "translate(15458 12225)",
    fill: "#737d88",
    opacity: 0.347
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219-2",
    "data-name": "Rectangle 219",
    width: 269,
    height: 77,
    rx: 10,
    transform: "translate(15799 12043)",
    fill: "#737d88",
    opacity: 0.588
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220-2",
    "data-name": "Rectangle 220",
    width: 225,
    height: 22,
    rx: 10,
    transform: "translate(15843 12190)",
    fill: "#737d88",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221-2",
    "data-name": "Rectangle 221",
    width: 189,
    height: 22,
    rx: 10,
    transform: "translate(15879 12225)",
    fill: "#737d88",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222-2",
    "data-name": "Rectangle 222",
    width: 269,
    height: 64,
    rx: 10,
    transform: "translate(15799 12557)",
    fill: "#737d88",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223-2",
    "data-name": "Rectangle 223",
    width: 269,
    height: 148,
    rx: 10,
    transform: "translate(15799 12358)",
    fill: "#737d88",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224-2",
    "data-name": "Rectangle 224",
    width: 358,
    height: 779,
    transform: "translate(15756 11906)",
    fill: "#d6e4e6",
    opacity: 0.617
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225-2",
    "data-name": "Rectangle 225",
    width: 709,
    height: 121,
    transform: "translate(15405 11906)",
    fill: "#0e7f8a",
    opacity: 0.173
  }), /*#__PURE__*/React.createElement("g", {
    id: "picture",
    transform: "translate(15458 12378.447)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632",
    transform: "translate(0 68.267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M217.857,68.267H26.143A26.143,26.143,0,0,0,0,94.41v122a26.143,26.143,0,0,0,26.143,26.143H217.857A26.143,26.143,0,0,0,244,216.41v-122A26.143,26.143,0,0,0,217.857,68.267Zm8.714,100.963-54.839-54.839a8.714,8.714,0,0,0-12.322,0L87.143,186.659l-28.7-28.7a8.714,8.714,0,0,0-12.322,0l-28.7,28.7V94.41A8.714,8.714,0,0,1,26.143,85.7H217.857a8.714,8.714,0,0,1,8.714,8.714V169.23Z",
    transform: "translate(0 -68.267)",
    fill: "#737d88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634",
    transform: "translate(52.347 102.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 26.174,
    cy: 26.174,
    r: 26.174,
    fill: "#737d88"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_517",
    "data-name": "Rectangle 517",
    width: 709,
    height: 779,
    transform: "translate(14649 23329.039)",
    fill: "#f0f7f8",
    opacity: 0.614
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_518",
    "data-name": "Rectangle 518",
    transform: "translate(15142 23356.039)",
    fill: "#0e7f8a",
    stroke: "#fff",
    strokeWidth: 4,
    opacity: 0.787
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 73,
    rx: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 166,
    height: 69,
    rx: 13,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    width: 189,
    height: 22,
    rx: 10,
    transform: "translate(14702 23466.039)",
    fill: "#737d88",
    opacity: 0.347
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_520",
    "data-name": "Rectangle 520",
    width: 244,
    height: 42,
    rx: 10,
    transform: "translate(14702 23501.039)",
    fill: "#737d88",
    opacity: 0.347
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_521",
    "data-name": "Rectangle 521",
    width: 244,
    height: 55,
    rx: 10,
    transform: "translate(14702 23683.039)",
    fill: "#737d88",
    opacity: 0.347
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_522",
    "data-name": "Rectangle 522",
    width: 189,
    height: 22,
    rx: 10,
    transform: "translate(14702 23613.039)",
    fill: "#737d88",
    opacity: 0.347
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_523",
    "data-name": "Rectangle 523",
    width: 189,
    height: 22,
    rx: 10,
    transform: "translate(14702 23648.039)",
    fill: "#737d88",
    opacity: 0.347
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_524",
    "data-name": "Rectangle 524",
    width: 269,
    height: 77,
    rx: 10,
    transform: "translate(15043 23466.039)",
    fill: "#737d88",
    opacity: 0.588
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_525",
    "data-name": "Rectangle 525",
    width: 225,
    height: 22,
    rx: 10,
    transform: "translate(15087 23613.039)",
    fill: "#737d88",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_526",
    "data-name": "Rectangle 526",
    width: 189,
    height: 22,
    rx: 10,
    transform: "translate(15123 23648.039)",
    fill: "#737d88",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_527",
    "data-name": "Rectangle 527",
    width: 269,
    height: 64,
    rx: 10,
    transform: "translate(15043 23980.039)",
    fill: "#737d88",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_528",
    "data-name": "Rectangle 528",
    width: 709,
    height: 121,
    transform: "translate(14649 23329.039)",
    fill: "#0e7f8a",
    opacity: 0.173
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_529",
    "data-name": "Rectangle 529",
    width: 244,
    height: 228,
    rx: 10,
    transform: "translate(14702 23816.039)",
    fill: "#737d88",
    opacity: 0.347
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_530",
    "data-name": "Rectangle 530",
    width: 358,
    height: 779,
    transform: "translate(15000 23329.039)",
    fill: "#d6e4e6",
    opacity: 0.617
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    d: "M-813.28-.92a21.751,21.751,0,0,0,9.48,2.04A22.006,22.006,0,0,0-794.12-1a17.253,17.253,0,0,0,6.92-5.8,14,14,0,0,0,2.52-8.08,14.225,14.225,0,0,0-3.72-10.08,27.512,27.512,0,0,0-10.12-6.56l-4.4-1.68a19.548,19.548,0,0,1-5.84-3.16,5.586,5.586,0,0,1-2-4.44,5.536,5.536,0,0,1,2-4.32,7.127,7.127,0,0,1,4.88-1.76,6.87,6.87,0,0,1,5.08,1.8,8.028,8.028,0,0,1,2.2,4.76l9.6-1.76a14.689,14.689,0,0,0-2.6-7.6,16.62,16.62,0,0,0-6.28-5.44,18.56,18.56,0,0,0-8.56-2,18.48,18.48,0,0,0-8.8,2.08,16.139,16.139,0,0,0-6.2,5.68,14.785,14.785,0,0,0-2.28,8.08q0,11.68,13.12,16.72l3.76,1.44a27.035,27.035,0,0,1,6.72,3.32,5.224,5.224,0,0,1,2.32,4.36,5.475,5.475,0,0,1-2.36,4.52,9.816,9.816,0,0,1-6.12,1.8,9.263,9.263,0,0,1-6.2-2,8.355,8.355,0,0,1-2.84-5.44l-9.76,1.84a15.626,15.626,0,0,0,2.92,8.12A17.562,17.562,0,0,0-813.28-.92Zm44.68-1.04a23.649,23.649,0,0,0,12,3.08,22.707,22.707,0,0,0,12.88-3.84,23.694,23.694,0,0,0,8.64-10.32h-11.76a10.739,10.739,0,0,1-4.2,3.48,12.752,12.752,0,0,1-5.56,1.24,12.022,12.022,0,0,1-8.24-2.96A12.845,12.845,0,0,1-769-19.12h35.52a17.226,17.226,0,0,0,.32-3.52,24.434,24.434,0,0,0-3.04-12.2,22.122,22.122,0,0,0-8.4-8.48,23.649,23.649,0,0,0-12-3.08,23.649,23.649,0,0,0-12,3.08,22.122,22.122,0,0,0-8.4,8.48,24.434,24.434,0,0,0-3.04,12.2A24.434,24.434,0,0,0-777-10.44,22.122,22.122,0,0,0-768.6-1.96Zm24.4-24.52H-769a12.976,12.976,0,0,1,4.24-7.72,12.011,12.011,0,0,1,8.16-2.92,12.01,12.01,0,0,1,8.16,2.92A12.975,12.975,0,0,1-744.2-26.48ZM-715.8,0V-64h-10.64V0Zm18.32-1.96a23.649,23.649,0,0,0,12,3.08A22.707,22.707,0,0,0-672.6-2.72a23.694,23.694,0,0,0,8.64-10.32h-11.76a10.739,10.739,0,0,1-4.2,3.48,12.752,12.752,0,0,1-5.56,1.24,12.022,12.022,0,0,1-8.24-2.96,12.845,12.845,0,0,1-4.16-7.84h35.52a17.226,17.226,0,0,0,.32-3.52,24.434,24.434,0,0,0-3.04-12.2,22.122,22.122,0,0,0-8.4-8.48,23.649,23.649,0,0,0-12-3.08,23.649,23.649,0,0,0-12,3.08,22.122,22.122,0,0,0-8.4,8.48,24.434,24.434,0,0,0-3.04,12.2,24.434,24.434,0,0,0,3.04,12.2A22.122,22.122,0,0,0-697.48-1.96Zm24.4-24.52h-24.8a12.976,12.976,0,0,1,4.24-7.72,12.011,12.011,0,0,1,8.16-2.92,12.01,12.01,0,0,1,8.16,2.92A12.975,12.975,0,0,1-673.08-26.48ZM-645.88-2A23.846,23.846,0,0,0-633.8,1.12a22.909,22.909,0,0,0,11.68-2.96V-14a14.94,14.94,0,0,1-5.2,3.76,15.555,15.555,0,0,1-6.24,1.28,13.254,13.254,0,0,1-6.64-1.72,12.781,12.781,0,0,1-4.84-4.84,13.675,13.675,0,0,1-1.8-6.96,14.049,14.049,0,0,1,1.8-7.08,13.3,13.3,0,0,1,4.84-4.96,12.944,12.944,0,0,1,6.72-1.8,15.363,15.363,0,0,1,6.16,1.28,14.94,14.94,0,0,1,5.2,3.76V-43.44A22.364,22.364,0,0,0-633.8-46.4a23.846,23.846,0,0,0-12.08,3.12,22.743,22.743,0,0,0-8.56,8.56,23.846,23.846,0,0,0-3.12,12.08,23.846,23.846,0,0,0,3.12,12.08A22.743,22.743,0,0,0-645.88-2Zm43.68.84A18.534,18.534,0,0,0-593,1.12,21.6,21.6,0,0,0-586.28.08V-9.44a17.661,17.661,0,0,1-5.6.96,8.859,8.859,0,0,1-5.6-1.68q-2.8-2.16-2.8-6.8V-35.12h14V-45.28h-14V-59.52H-601l-9.92,5.84v8.4l-8.96,9.44v.72h8.96V-16.8a18.381,18.381,0,0,0,2.32,9.32A16.564,16.564,0,0,0-602.2-1.16ZM-559.64,0h10.88V-20.64h7.92A20.761,20.761,0,0,0-531-22.92a17.077,17.077,0,0,0,6.76-6.28,17.16,17.16,0,0,0,2.44-9.12,17.368,17.368,0,0,0-2.44-9.16A16.707,16.707,0,0,0-531-53.76,21.064,21.064,0,0,0-540.84-56h-18.8Zm18.8-30.8h-7.92V-45.44h7.92a8.525,8.525,0,0,1,5.96,2,6.889,6.889,0,0,1,2.2,5.36,6.736,6.736,0,0,1-2.24,5.28A8.556,8.556,0,0,1-540.84-30.8Zm33.16,28.84a21.144,21.144,0,0,0,11.32,3.08q10,0,15.44-7.52V0h10.72V-45.28h-10.72v6.4q-5.44-7.52-15.44-7.52a21.144,21.144,0,0,0-11.32,3.08,21.78,21.78,0,0,0-7.88,8.48,25.516,25.516,0,0,0-2.88,12.2,25.516,25.516,0,0,0,2.88,12.2A21.78,21.78,0,0,0-507.68-1.96Zm20.08-8.84a12.937,12.937,0,0,1-6.76,1.84,12.937,12.937,0,0,1-6.76-1.84A13.6,13.6,0,0,1-506-15.76a13.522,13.522,0,0,1-1.8-6.88,13.522,13.522,0,0,1,1.8-6.88,13.6,13.6,0,0,1,4.88-4.96,12.937,12.937,0,0,1,6.76-1.84,12.937,12.937,0,0,1,6.76,1.84,13.6,13.6,0,0,1,4.88,4.96,13.522,13.522,0,0,1,1.8,6.88,13.522,13.522,0,0,1-1.8,6.88A13.6,13.6,0,0,1-487.6-10.8ZM-451,15.12a32,32,0,0,0,11.84,2q9.84,0,16.08-4.16a17.779,17.779,0,0,0,6-6.68A20.079,20.079,0,0,0-415-3.04V-45.28h-10.72v6.4q-5.44-7.52-15.44-7.52a21.632,21.632,0,0,0-11.28,3,21.245,21.245,0,0,0-7.92,8.32,24.547,24.547,0,0,0-2.88,11.88,24.547,24.547,0,0,0,2.88,11.88A21.245,21.245,0,0,0-452.44-3a21.632,21.632,0,0,0,11.28,3q10,0,15.44-7.52v4.48a9.676,9.676,0,0,1-3.76,8.16q-3.6,2.72-9.68,2.72a19.606,19.606,0,0,1-6.8-1.04A8.2,8.2,0,0,1-451.08,2h-11.6a17.925,17.925,0,0,0,4.12,7.96A20.181,20.181,0,0,0-451,15.12Zm18.6-26.92a13.63,13.63,0,0,1-6.76,1.72,13.387,13.387,0,0,1-6.76-1.76,13.266,13.266,0,0,1-4.88-4.76,12.588,12.588,0,0,1-1.8-6.6,12.588,12.588,0,0,1,1.8-6.6,13.266,13.266,0,0,1,4.88-4.76,13.387,13.387,0,0,1,6.76-1.76,13.63,13.63,0,0,1,6.76,1.72,12.96,12.96,0,0,1,4.88,4.72,12.734,12.734,0,0,1,1.8,6.68,12.734,12.734,0,0,1-1.8,6.68A12.96,12.96,0,0,1-432.4-11.8Zm35.64,9.84a23.649,23.649,0,0,0,12,3.08,22.707,22.707,0,0,0,12.88-3.84,23.694,23.694,0,0,0,8.64-10.32H-375a10.739,10.739,0,0,1-4.2,3.48,12.752,12.752,0,0,1-5.56,1.24A12.022,12.022,0,0,1-393-11.28a12.845,12.845,0,0,1-4.16-7.84h35.52a17.226,17.226,0,0,0,.32-3.52,24.434,24.434,0,0,0-3.04-12.2,22.122,22.122,0,0,0-8.4-8.48,23.649,23.649,0,0,0-12-3.08,23.649,23.649,0,0,0-12,3.08,22.122,22.122,0,0,0-8.4,8.48,24.434,24.434,0,0,0-3.04,12.2,24.434,24.434,0,0,0,3.04,12.2A22.122,22.122,0,0,0-396.76-1.96Zm24.4-24.52h-24.8a12.976,12.976,0,0,1,4.24-7.72,12.011,12.011,0,0,1,8.16-2.92,12.011,12.011,0,0,1,8.16,2.92A12.976,12.976,0,0,1-372.36-26.48ZM-351.88-2.4A18.336,18.336,0,0,0-340.6,1.12a18.93,18.93,0,0,0,8.2-1.76,14.8,14.8,0,0,0,5.88-4.8,11.342,11.342,0,0,0,2.16-6.72,10.959,10.959,0,0,0-3.16-8.16,25.858,25.858,0,0,0-9-5.36l-3.28-1.28a15.376,15.376,0,0,1-4.64-2.64,4.565,4.565,0,0,1-1.36-3.36,3.749,3.749,0,0,1,1.4-2.96,5.16,5.16,0,0,1,3.48-1.2,5.486,5.486,0,0,1,3.8,1.4,6.1,6.1,0,0,1,1.96,3.48l8.88-1.68a12.766,12.766,0,0,0-4.84-9.04,16.016,16.016,0,0,0-10.36-3.44,15.914,15.914,0,0,0-7.36,1.72,13.137,13.137,0,0,0-5.28,4.8,12.67,12.67,0,0,0-1.92,6.84,12.411,12.411,0,0,0,2.8,8.08,18.171,18.171,0,0,0,7.84,5.36l3.52,1.36a22.189,22.189,0,0,1,5.12,2.56A3.57,3.57,0,0,1-335-12.64a3.83,3.83,0,0,1-1.76,3.2,7.284,7.284,0,0,1-4.4,1.28,7.341,7.341,0,0,1-4.6-1.44,6.347,6.347,0,0,1-2.36-4.08L-357.48-12A13.98,13.98,0,0,0-351.88-2.4Zm79,1.48a20.178,20.178,0,0,0,9.08,2.04,26.233,26.233,0,0,0,17.52-6.64L-241.16,0h13.2l-11.6-12.32,9.28-11.28-6.88-6.32L-246.2-19.2l-8.16-8.88q10.64-6.24,10.64-15.04a13.031,13.031,0,0,0-2.04-7.08,14.143,14.143,0,0,0-5.6-5.08,17.077,17.077,0,0,0-7.96-1.84,17.5,17.5,0,0,0-8.08,1.88,14.955,14.955,0,0,0-5.8,5.08,12.482,12.482,0,0,0-2.12,7.04,14.244,14.244,0,0,0,1.36,6,31.755,31.755,0,0,0,4.48,6.72,31.031,31.031,0,0,0-9.2,7.2,13.9,13.9,0,0,0-3.12,9.04,13.3,13.3,0,0,0,2.4,7.72A16.777,16.777,0,0,0-272.88-.92Zm17.8-36.56a18.332,18.332,0,0,1-5.2,3.24,27.39,27.39,0,0,1-3.2-4.16,7.13,7.13,0,0,1-1.04-3.68,4.713,4.713,0,0,1,1.64-3.64,5.918,5.918,0,0,1,4.12-1.48,5.58,5.58,0,0,1,4,1.52,4.979,4.979,0,0,1,1.6,3.76A5.845,5.845,0,0,1-255.08-37.48Zm2.16,25a13.9,13.9,0,0,1-9.76,4.16,9.243,9.243,0,0,1-5.84-1.8,5.5,5.5,0,0,1-2.32-4.52,6.254,6.254,0,0,1,1.52-4.08,27.1,27.1,0,0,1,6.16-4.72ZM-186.84,0h22.8A19.937,19.937,0,0,0-155-2a15.63,15.63,0,0,0,6.28-5.52,14.253,14.253,0,0,0,2.28-7.92,13.982,13.982,0,0,0-2.36-8.04,15.612,15.612,0,0,0-7.08-5.48q7.44-3.84,7.44-11.6a14.3,14.3,0,0,0-4.72-11.24q-4.72-4.2-12.48-4.2h-21.2Zm20.8-33.04h-9.92V-46.4h9.84a6.647,6.647,0,0,1,4.84,1.92,6.444,6.444,0,0,1,1.96,4.8,6.526,6.526,0,0,1-1.84,4.76A6.519,6.519,0,0,1-166.04-33.04Zm1.52,23.44h-11.44V-23.76h11.28a7.243,7.243,0,0,1,5.36,2,6.833,6.833,0,0,1,2,5.04,6.827,6.827,0,0,1-2.08,5.08A7.029,7.029,0,0,1-164.52-9.6ZM-128.36,0V-64H-139V0Zm17.72-1.96A21.143,21.143,0,0,0-99.32,1.12q10,0,15.44-7.52V0h10.72V-45.28H-83.88v6.4q-5.44-7.52-15.44-7.52a21.143,21.143,0,0,0-11.32,3.08,21.78,21.78,0,0,0-7.88,8.48,25.516,25.516,0,0,0-2.88,12.2,25.516,25.516,0,0,0,2.88,12.2A21.78,21.78,0,0,0-110.64-1.96Zm20.08-8.84a12.937,12.937,0,0,1-6.76,1.84,12.937,12.937,0,0,1-6.76-1.84,13.6,13.6,0,0,1-4.88-4.96,13.522,13.522,0,0,1-1.8-6.88,13.522,13.522,0,0,1,1.8-6.88,13.6,13.6,0,0,1,4.88-4.96,12.937,12.937,0,0,1,6.76-1.84,12.937,12.937,0,0,1,6.76,1.84,13.6,13.6,0,0,1,4.88,4.96,13.522,13.522,0,0,1,1.8,6.88,13.522,13.522,0,0,1-1.8,6.88A13.6,13.6,0,0,1-90.56-10.8ZM-54.68-2A23.846,23.846,0,0,0-42.6,1.12,22.909,22.909,0,0,0-30.92-1.84V-14a14.939,14.939,0,0,1-5.2,3.76,15.555,15.555,0,0,1-6.24,1.28A13.254,13.254,0,0,1-49-10.68a12.781,12.781,0,0,1-4.84-4.84,13.675,13.675,0,0,1-1.8-6.96,14.049,14.049,0,0,1,1.8-7.08A13.3,13.3,0,0,1-49-34.52a12.944,12.944,0,0,1,6.72-1.8,15.363,15.363,0,0,1,6.16,1.28,14.94,14.94,0,0,1,5.2,3.76V-43.44A22.364,22.364,0,0,0-42.6-46.4a23.846,23.846,0,0,0-12.08,3.12,22.743,22.743,0,0,0-8.56,8.56,23.846,23.846,0,0,0-3.12,12.08,23.846,23.846,0,0,0,3.12,12.08A22.743,22.743,0,0,0-54.68-2Zm41.76,2V-64H-23.56V0ZM15.72,0-1.16-23.44,14.52-45.28H2.68l-15.6,21.84L3.4,0ZM48.04-2.04A24.044,24.044,0,0,0,60.2,1.12,24.044,24.044,0,0,0,72.36-2.04a23.772,23.772,0,0,0,8.76-8.6,23.013,23.013,0,0,0,3.24-12,23.013,23.013,0,0,0-3.24-12,23.772,23.772,0,0,0-8.76-8.6A24.044,24.044,0,0,0,60.2-46.4a24.044,24.044,0,0,0-12.16,3.16,23.466,23.466,0,0,0-8.72,8.6,23.233,23.233,0,0,0-3.2,12,23.233,23.233,0,0,0,3.2,12A23.466,23.466,0,0,0,48.04-2.04ZM66.96-10.8A12.937,12.937,0,0,1,60.2-8.96a12.937,12.937,0,0,1-6.76-1.84,13.6,13.6,0,0,1-4.88-4.96,13.522,13.522,0,0,1-1.8-6.88,13.522,13.522,0,0,1,1.8-6.88,13.6,13.6,0,0,1,4.88-4.96,12.937,12.937,0,0,1,6.76-1.84,12.937,12.937,0,0,1,6.76,1.84,13.6,13.6,0,0,1,4.88,4.96,13.522,13.522,0,0,1,1.8,6.88,13.522,13.522,0,0,1-1.8,6.88A13.6,13.6,0,0,1,66.96-10.8Zm38.52-36.24q0-4.4,2.4-6.56a8.976,8.976,0,0,1,5.92-1.92,17.888,17.888,0,0,1,5.68.96v-9.52a21.6,21.6,0,0,0-6.72-1.04,18.7,18.7,0,0,0-9.28,2.28,15.942,15.942,0,0,0-6.36,6.52,20.462,20.462,0,0,0-2.28,9.84v1.2l-8.96,9.36v.8h8.88V0h10.72V-35.12h14V-45.28H105.56Zm34.56,0q0-4.4,2.4-6.56a8.976,8.976,0,0,1,5.92-1.92,17.888,17.888,0,0,1,5.68.96v-9.52a21.6,21.6,0,0,0-6.72-1.04,18.7,18.7,0,0,0-9.28,2.28,15.942,15.942,0,0,0-6.36,6.52,20.462,20.462,0,0,0-2.28,9.84v1.2l-8.96,9.36v.8h8.88V0h10.72V-35.12h14V-45.28H140.12Zm44-8.96H171.32l20,30.4V0H202.2V-25.68L222.2-56H209.48l-12.8,18.96Zm45.6,53.96A24.044,24.044,0,0,0,241.8,1.12a24.044,24.044,0,0,0,12.16-3.16,23.772,23.772,0,0,0,8.76-8.6,23.013,23.013,0,0,0,3.24-12,23.013,23.013,0,0,0-3.24-12,23.772,23.772,0,0,0-8.76-8.6A24.044,24.044,0,0,0,241.8-46.4a24.044,24.044,0,0,0-12.16,3.16,23.466,23.466,0,0,0-8.72,8.6,23.233,23.233,0,0,0-3.2,12,23.233,23.233,0,0,0,3.2,12A23.466,23.466,0,0,0,229.64-2.04Zm18.92-8.76a12.937,12.937,0,0,1-6.76,1.84,12.937,12.937,0,0,1-6.76-1.84,13.6,13.6,0,0,1-4.88-4.96,13.522,13.522,0,0,1-1.8-6.88,13.522,13.522,0,0,1,1.8-6.88,13.6,13.6,0,0,1,4.88-4.96,12.937,12.937,0,0,1,6.76-1.84,12.937,12.937,0,0,1,6.76,1.84,13.6,13.6,0,0,1,4.88,4.96,13.522,13.522,0,0,1,1.8,6.88,13.522,13.522,0,0,1-1.8,6.88A13.6,13.6,0,0,1,248.56-10.8Zm29.88,8.48q4.32,3.44,11.12,3.44a18.808,18.808,0,0,0,7.8-1.6,14.264,14.264,0,0,0,5.88-4.88V0h10.64V-45.28H303.24v25.52q0,5.2-2.8,8.04t-7.92,2.84a10.241,10.241,0,0,1-7-2.28,7.918,7.918,0,0,1-2.6-6.28V-45.28H272.28v29.52a18.262,18.262,0,0,0,1.6,7.72A14.8,14.8,0,0,0,278.44-2.32ZM323,0h10.64V-22.64a14.362,14.362,0,0,1,1.16-5.84,11.656,11.656,0,0,1,3.16-4.32,10.718,10.718,0,0,1,6.8-2.32,10.519,10.519,0,0,1,5.52,1.44l3.04-10.72a13.984,13.984,0,0,0-6.88-1.68,14.163,14.163,0,0,0-7.76,2.24,12.553,12.553,0,0,0-5.04,6.16v-7.6H323Zm57.6,0,3.68-8.64h22.64L410.6,0h11.92L396.04-57.12h-.88L368.68,0Zm14.96-35.28,7.68,17.68H387.96ZM427,16h10.64V-6.4q5.44,7.52,15.44,7.52A21.143,21.143,0,0,0,464.4-1.96a21.78,21.78,0,0,0,7.88-8.48,25.516,25.516,0,0,0,2.88-12.2,25.516,25.516,0,0,0-2.88-12.2,21.78,21.78,0,0,0-7.88-8.48,21.143,21.143,0,0,0-11.32-3.08q-10,0-15.44,7.52v-6.4H427Zm30.84-26.8a12.937,12.937,0,0,1-6.76,1.84,12.937,12.937,0,0,1-6.76-1.84,13.6,13.6,0,0,1-4.88-4.96,13.522,13.522,0,0,1-1.8-6.88,13.522,13.522,0,0,1,1.8-6.88,13.6,13.6,0,0,1,4.88-4.96,12.937,12.937,0,0,1,6.76-1.84,12.937,12.937,0,0,1,6.76,1.84,13.6,13.6,0,0,1,4.88,4.96,13.522,13.522,0,0,1,1.8,6.88,13.522,13.522,0,0,1-1.8,6.88A13.6,13.6,0,0,1,457.84-10.8ZM482.12,16h10.64V-6.4q5.44,7.52,15.44,7.52a21.144,21.144,0,0,0,11.32-3.08,21.781,21.781,0,0,0,7.88-8.48,25.516,25.516,0,0,0,2.88-12.2,25.516,25.516,0,0,0-2.88-12.2,21.781,21.781,0,0,0-7.88-8.48A21.144,21.144,0,0,0,508.2-46.4q-10,0-15.44,7.52v-6.4H482.12Zm30.84-26.8a12.937,12.937,0,0,1-6.76,1.84,12.937,12.937,0,0,1-6.76-1.84,13.6,13.6,0,0,1-4.88-4.96,13.522,13.522,0,0,1-1.8-6.88,13.522,13.522,0,0,1,1.8-6.88,13.6,13.6,0,0,1,4.88-4.96,12.937,12.937,0,0,1,6.76-1.84,12.937,12.937,0,0,1,6.76,1.84,13.6,13.6,0,0,1,4.88,4.96,13.522,13.522,0,0,1,1.8,6.88,13.522,13.522,0,0,1-1.8,6.88A13.6,13.6,0,0,1,512.96-10.8ZM547.88,0V-64H537.24V0Zm10.04-53.4a6.033,6.033,0,0,0,4.44,1.8,5.938,5.938,0,0,0,4.36-1.8,5.938,5.938,0,0,0,1.8-4.36,6.033,6.033,0,0,0-1.8-4.44,5.938,5.938,0,0,0-4.36-1.8,6.033,6.033,0,0,0-4.44,1.8,6.033,6.033,0,0,0-1.8,4.44A5.938,5.938,0,0,0,557.92-53.4ZM567.64,0V-45.28H557V0ZM586.2-2a23.846,23.846,0,0,0,12.08,3.12,22.909,22.909,0,0,0,11.68-2.96V-14a14.94,14.94,0,0,1-5.2,3.76,15.555,15.555,0,0,1-6.24,1.28,13.254,13.254,0,0,1-6.64-1.72,12.781,12.781,0,0,1-4.84-4.84,13.675,13.675,0,0,1-1.8-6.96,14.049,14.049,0,0,1,1.8-7.08,13.3,13.3,0,0,1,4.84-4.96,12.944,12.944,0,0,1,6.72-1.8,15.363,15.363,0,0,1,6.16,1.28,14.94,14.94,0,0,1,5.2,3.76V-43.44a22.364,22.364,0,0,0-11.68-2.96,23.846,23.846,0,0,0-12.08,3.12,22.743,22.743,0,0,0-8.56,8.56,23.846,23.846,0,0,0-3.12,12.08,23.846,23.846,0,0,0,3.12,12.08A22.743,22.743,0,0,0,586.2-2Zm39.24.04a21.144,21.144,0,0,0,11.32,3.08q10,0,15.44-7.52V0h10.72V-45.28H652.2v6.4q-5.44-7.52-15.44-7.52a21.144,21.144,0,0,0-11.32,3.08,21.78,21.78,0,0,0-7.88,8.48,25.516,25.516,0,0,0-2.88,12.2,25.516,25.516,0,0,0,2.88,12.2A21.78,21.78,0,0,0,625.44-1.96Zm20.08-8.84a12.937,12.937,0,0,1-6.76,1.84A12.937,12.937,0,0,1,632-10.8a13.6,13.6,0,0,1-4.88-4.96,13.522,13.522,0,0,1-1.8-6.88,13.522,13.522,0,0,1,1.8-6.88A13.6,13.6,0,0,1,632-34.48a12.937,12.937,0,0,1,6.76-1.84,12.937,12.937,0,0,1,6.76,1.84,13.6,13.6,0,0,1,4.88,4.96,13.522,13.522,0,0,1,1.8,6.88,13.522,13.522,0,0,1-1.8,6.88A13.6,13.6,0,0,1,645.52-10.8Zm39,9.64a18.534,18.534,0,0,0,9.2,2.28A21.6,21.6,0,0,0,700.44.08V-9.44a17.661,17.661,0,0,1-5.6.96,8.859,8.859,0,0,1-5.6-1.68q-2.8-2.16-2.8-6.8V-35.12h14V-45.28h-14V-59.52h-.72l-9.92,5.84v8.4l-8.96,9.44v.72h8.96V-16.8a18.381,18.381,0,0,0,2.32,9.32A16.564,16.564,0,0,0,684.52-1.16Zm23.8-52.24a6.033,6.033,0,0,0,4.44,1.8,5.938,5.938,0,0,0,4.36-1.8,5.938,5.938,0,0,0,1.8-4.36,6.033,6.033,0,0,0-1.8-4.44,5.938,5.938,0,0,0-4.36-1.8,6.033,6.033,0,0,0-4.44,1.8,6.033,6.033,0,0,0-1.8,4.44A5.938,5.938,0,0,0,708.32-53.4ZM718.04,0V-45.28H707.4V0Zm18.8-2.04A24.044,24.044,0,0,0,749,1.12a24.044,24.044,0,0,0,12.16-3.16,23.773,23.773,0,0,0,8.76-8.6,23.014,23.014,0,0,0,3.24-12,23.014,23.014,0,0,0-3.24-12,23.773,23.773,0,0,0-8.76-8.6A24.044,24.044,0,0,0,749-46.4a24.044,24.044,0,0,0-12.16,3.16,23.466,23.466,0,0,0-8.72,8.6,23.233,23.233,0,0,0-3.2,12,23.233,23.233,0,0,0,3.2,12A23.466,23.466,0,0,0,736.84-2.04Zm18.92-8.76A12.937,12.937,0,0,1,749-8.96a12.937,12.937,0,0,1-6.76-1.84,13.6,13.6,0,0,1-4.88-4.96,13.522,13.522,0,0,1-1.8-6.88,13.522,13.522,0,0,1,1.8-6.88,13.6,13.6,0,0,1,4.88-4.96A12.937,12.937,0,0,1,749-36.32a12.937,12.937,0,0,1,6.76,1.84,13.6,13.6,0,0,1,4.88,4.96,13.522,13.522,0,0,1,1.8,6.88,13.522,13.522,0,0,1-1.8,6.88A13.6,13.6,0,0,1,755.76-10.8ZM779.96,0H790.6V-25.52q0-5.28,2.84-8.08t7.88-2.8a10.241,10.241,0,0,1,7,2.28,7.918,7.918,0,0,1,2.6,6.28V0h10.64V-29.52a18,18,0,0,0-1.8-8.16,14.351,14.351,0,0,0-5.16-5.76,17.125,17.125,0,0,0-10.32-2.96,18.808,18.808,0,0,0-7.8,1.6,14.264,14.264,0,0,0-5.88,4.88v-5.36H779.96Z",
    transform: "translate(15006 23194.039)",
    fill: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_531",
    "data-name": "Rectangle 531",
    transform: "translate(14617 23296.039)",
    fill: "rgba(255,255,255,0)",
    stroke: "#397d88",
    strokeWidth: 8,
    opacity: 0.862
  }, /*#__PURE__*/React.createElement("rect", {
    width: 773,
    height: 846,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 765,
    height: 838,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_532",
    "data-name": "Rectangle 532",
    transform: "translate(13755.999 23295.039)",
    fill: "rgba(255,255,255,0)",
    stroke: "#b7c0c9",
    strokeWidth: 8,
    opacity: 0.786
  }, /*#__PURE__*/React.createElement("rect", {
    width: 773,
    height: 846,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 765,
    height: 838,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1548",
    "data-name": "Path 1548",
    transform: "translate(15479 23295.039)",
    fill: "rgba(255,255,255,0)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 769 842 L 469.9642333984375 842 L 4 842 L 4 4 L 769 4 L 769 842 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8 8 L 8 838 L 469.9642333984375 838 L 765 838 L 765 8 L 8 8 M 0 0 L 773 0 L 773 846 L 469.9642333984375 846 L 0 846 L 0 0 Z",
    stroke: "none",
    fill: "#397d88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(15504 23316.871)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_146",
    "data-name": "Ellipse 146",
    cx: 59.108,
    cy: 59.069,
    rx: 59.108,
    ry: 59.069,
    transform: "translate(0 0.168)",
    fill: "#2c9ca7",
    opacity: 0.995
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M142.379,193.975,114.432,172.2l7.946-10.2,17.162,13.369L167.863,134.5l10.628,7.363Z",
    transform: "translate(-88.011 -103.319)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "check-2",
    "data-name": "check",
    transform: "translate(14638 23316.871)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_146-2",
    "data-name": "Ellipse 146",
    cx: 59.108,
    cy: 59.069,
    rx: 59.108,
    ry: 59.069,
    transform: "translate(0 0.168)",
    fill: "#2c9ca7",
    opacity: 0.995
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071-2",
    "data-name": "Path 1071",
    d: "M142.379,193.975,114.432,172.2l7.946-10.2,17.162,13.369L167.863,134.5l10.628,7.363Z",
    transform: "translate(-88.011 -103.319)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "check-3",
    "data-name": "check",
    transform: "translate(13777.999 23316.871)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_146-3",
    "data-name": "Ellipse 146",
    cx: 59.108,
    cy: 59.069,
    rx: 59.108,
    ry: 59.069,
    transform: "translate(0 0.168)",
    fill: "#c2cad1",
    opacity: 0.995
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071-3",
    "data-name": "Path 1071",
    d: "M142.379,193.975,114.432,172.2l7.946-10.2,17.162,13.369L167.863,134.5l10.628,7.363Z",
    transform: "translate(-88.011 -103.319)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_605",
    "data-name": "Rectangle 605",
    width: 265,
    height: 79,
    transform: "translate(13837 23499.664)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_606",
    "data-name": "Rectangle 606",
    width: 269,
    height: 174,
    transform: "translate(15043 23755.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cursor_1_",
    "data-name": "cursor (1)",
    d: "M73.087,67.427,6.433.8A3.8,3.8,0,0,0,.32,3.608V94.666a3.693,3.693,0,0,0,3.692,3.691,3.5,3.5,0,0,0,2.407-.9l18.467-16.09,15.062,35.187a2.469,2.469,0,0,0,1.344,1.319,2.573,2.573,0,0,0,.916.172,2.47,2.47,0,0,0,.97-.2l15.848-6.793a2.455,2.455,0,0,0,1.3-3.228L45.74,73.747H70.459a3.693,3.693,0,0,0,3.691-3.691A4.1,4.1,0,0,0,73.087,67.427Zm0,0",
    transform: "translate(15311.68 23929.664)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.b6d2862a269fad88cc6c2c235244983b.svg";
export { ForwardRef as ReactComponent };